<template>
  <el-dialog title="调入合同" :visible.sync="disableDialog" width="60%">
    <el-form>
      <el-row :gutter="20">
        <el-col :span="14">
          <el-col :span="8">
            <el-select v-model="queryParams.column" @change="changeColumn">
              <el-option
                v-for="(item,index) in searchList"
                :label="item.label"
                :value="item.value"
                :key="index"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-input v-model="queryParams.value" placeholder="请输入关键词"></el-input>
          </el-col>
          <el-col :span="8">
            <el-button @click="onSearch" type="primary">搜索</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-col>
        </el-col>
      </el-row>
    </el-form>
    <el-table
      style="margin-top:20px;"
      :data="list"
      @current-change="handleChange"
      highlight-current-row
      tooltip-effect="dark"
      :header-cell-style="tableHeader"
      v-loading="loadingTable"
      element-loading-text="拼命加载中请稍后..."
      element-loading-spinner="el-icon-loading"
      border
      height="378"
    >
      <el-table-column prop="contractCode" label="合同编号" width="150"></el-table-column>
      <el-table-column prop="cusName" label="客户名称" min-width="150" show-overflow-tooltip></el-table-column>
      <el-table-column prop="contractTotal" label="合同金额" min-width="90">
        <template slot-scope="scope">{{scope.row.contractTotal|priceFilter}}</template>
      </el-table-column>
      <el-table-column prop="contractCost" label="供货成本" min-width="90">
        <template slot-scope="scope">{{scope.row.contractCost|priceFilter}}</template>
      </el-table-column>
      <el-table-column prop="contractRate" label="毛利率">
        <template slot-scope="scope">{{scope.row.contractRate|perCentFilter}}</template>
      </el-table-column>
      <el-table-column label="签订时间" width="125">
        <template slot-scope="scope">{{scope.row.signDate|dateFilter}}</template>
      </el-table-column>
      <el-table-column label="产品清单" width="90">
        <template slot-scope="scope">
          <el-popover
            :open-delay="200"
            @show="onQueryByOcbId(1, scope.row)"
            placement="right"
            width="680"
            trigger="hover"
          >
            <el-table :data="gridData" border max-height="480">
              <el-table-column prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
              <el-table-column prop="seriesName" label="系列" show-overflow-tooltip></el-table-column>
              <el-table-column prop="proName" label="产品名称" show-overflow-tooltip></el-table-column>
              <el-table-column prop="proType" label="型号" show-overflow-tooltip></el-table-column>
              <el-table-column prop="orderNumber" label="订货号" show-overflow-tooltip></el-table-column>
              <el-table-column prop="ocNeednumber" label="数量" width="85"></el-table-column>
              <el-table-column prop="ocUnit" label="单位" width="50"></el-table-column>
              <el-table-column label="货期" width="65">
                <template slot-scope="scope">{{scope.row.ocExtime}}天</template>
              </el-table-column>
            </el-table>
            <el-button type="text" slot="reference">查看</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer">
      <el-button type="primary" @click="onQueryByOcbId(2)">提 交</el-button>
      <el-button @click="disableDialog = false">取 消</el-button>
    </span>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[30, 50, 100, 200]"
        :page-size="pageSize"
        :total="total"
      ></el-pagination>
    </div>
  </el-dialog>
</template>
<script>
import { searchList } from '../util/data'
import {
  orderBaseQueryAllByOwnId,
  queryOrderContractContent
} from '@/api/sell/sellManage'
export default {
  data () {
    return {
      queryParams: {
        column: 'cusName',
        value: ''
      },
      disableDialog: false,
      searchList, // 询价单搜索条件
      columnArr: [],
      list: [], // 询价单列表
      gridData: [], // 查看列表清单
      loadingTable: false, // 列表loading
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0 // 列表总数
    }
  },
  watch: {
    queryParams (val) {
      if (!val.column) {
        this.$set(this.queryParams, 'column', 'cusName')
      }
    }
  },
  methods: {
    // 调入报价单初始化方法
    onInitial () {
      this.disableDialog = true
      this.onReset()
    },
    onReset () {
      this.queryParams = {}
      this.pageSize = 30
      this.currentPage = 1
      this.columnArr = []
      this.getList()
    },
    // 搜索
    onSearch () {
      if (this.queryParams.column && this.queryParams.value) {
        this.pageSize = 30
        this.currentPage = 1
        this.columnArr = [this.queryParams]
        this.getList()
      } else {
        this.$message.error('搜索条件不能为空')
      }
    },
    changeColumn () {
      delete this.queryParams.value
    },
    // 调入报价单列表
    getList () {
      this.loadingTable = true
      this.queryParams.collection = true
      const params = {
        criteriaVoList: [...this.columnArr],
        queryPageName: ''
      }
      orderBaseQueryAllByOwnId(this.currentPage, this.pageSize, params).then(
        (res) => {
          if (res.data.code === 200) {
            this.loadingTable = false
            this.list = res.data.obj.records
            this.total = res.data.obj.total
          } else {
            this.$message.error(res.data.msg)
          }
        }
      )
    },
    // 确定调入报价单,查看产品清单
    onQueryByOcbId (type, data) {
      this.gridData = []
      if (!data && !this.checkObj) {
        this.$message.error('请选择需要导入的合同！')
        return
      }
      const obj = data || this.checkObj
      if (obj.id) {
        queryOrderContractContent(obj.id).then((res) => {
          if (res.data.code === 200) {
            res.data.obj.forEach((item) => {
              item.ocNeednumber = item.cbNumber
              item.ocExtime = item.cbExtimeValue
              item.ocFacePrice = item.cbFacePrice
              item.ocUnit = item.cbUnit
              item.ocDiscount = item.cbDiscount
              item.ocPrice = item.cbPrice
            })
            this.gridData = res.data.obj
            if (type === 2) {
              this.disableDialog = false
              this.$message.success('调用成功！')
              this.$emit('onTransferInContract', this.gridData)
            }
          } else {
            this.$message.error(res.data.msg)
          }
        })
      } else {
        this.$message.error('该数据不完整,没有id')
      }
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    handleChange (val) {
      // 列表选中的数据
      this.checkObj = val
    },
    // 页数
    handleSizeChange (val) {
      this.currentPage = 1
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>
